<template>
    <!-- 使用a标签实现跳转，包裹标签包裹图片 -->
        <a :href="link" :target="target" class="image-link-container" >
            <img :src="imageSrc" class="link-image">
        </a>

</template>

<script setup>
import { defineProps } from 'vue';

// 定义组件接收的属性
const props = defineProps({
    // 图片路径
    imageSrc: {
        type: String,
        required: true,
        description: '图片的路径或URL'
    },
    // 跳转链接
    link: {
        type: String,
        required: true,
        description: '点击图片后跳转的链接地址'
    },
    // 链接打开方式：_blank（新窗口）或 _self（当前窗口）
    target: {
        type: String,
        default: '_self',
        validator: (value) => {
            // 验证只能是指定的值
            return ['_self', '_blank'].includes(value);
        },
        description: '链接打开方式，_self为当前窗口，_blank为新窗口'
    },
});

</script>

<style scoped>


.image-link-container {
    padding: 16px;
    display: inline-block;
    /* 移除a标签默认下划线 */
    text-decoration: none;
    /* 可选：添加鼠标悬停效果 */
    transition: transform 0.2s ease;
}

.image-link-container:hover {
    transform: scale(1.02);
}

.link-image {
    /* 确保图片自适应容器 */
    max-width: 100%;
    height: auto;
    /* 可选：添加边框和圆角 */
    border-radius: 4px;
    border: none;
}
</style>
